import { render, staticRenderFns } from "./NavbarDesktop.vue?vue&type=template&id=0b651fa9"
import script from "./NavbarDesktop.vue?vue&type=script&lang=js"
export * from "./NavbarDesktop.vue?vue&type=script&lang=js"
import style0 from "./NavbarDesktop.vue?vue&type=style&index=0&id=0b651fa9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports